import { useState } from 'react'
import { useJobsStore } from '../../../../Store/useJobsStore'

export const useFilterSelect = () => {
    const setFilterState = useJobsStore((state) => state.setFilterState)
    const [value, setValue] = useState('')

    const onChange = (value, filterField) => {
        setValue(value)
        setFilterState(value, filterField, false, true)
    }

    const getFilterLabel = (item, filterField) => {
        switch (filterField) {
            case 'department':
                return item.label.split('(')[0]
            case 'location':
                return item.city
            case 'experienceLevel':
                return item.label
            default:
                return item.label
        }
    }

    return { onChange, value, getFilterLabel }
}
